import { SimulacaoResponse, Valores } from '@store/simulacaoSlice/type'

import { BaseServices } from './BaseService'
import { HttpMethod, TResponseType } from './types'

export default async ({ data, guid }: Payload): Promise<TResponseType<SimulacaoResponse>> => {
  const headers = {
    'Content-Type': 'application/json',
    guid,
  }

  const pathname = process.env.REACT_APP_POST_SIMULACAO
  const method = HttpMethod.PUT
  const host = process.env.REACT_APP_HOST

  const response = BaseServices.request<SimulacaoResponse>({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}

export interface Payload {
  guid: string
  data: Data
}
interface Data {
  saldoFgts?: number
  qtPeriodos?: number
  valores?: Valores
}
